import {NgModule} from '@angular/core';
import {CoreModule} from "../../core/core.module";
import {CwConfigPage} from "./page/overview/cw-config/cw-config.page";
import {CwCaseDashboardPage} from "./page/dashboard/cw-case-dashboard/cw-case-dashboard.page";
import {CwCaseObjectPage} from "./page/object/cw-case-object-page/cw-case-object.page";
// TM-1000002000: the three new surfaces around „Meine Anträge" / „Meine Vorgänge".
//   - CwCaseMinePage        — Alpha page cw/case/mine (the consultant's own Vorgangsliste);
//   - CwCaseDocumentsPage   — cw/case/:id/documents, the reduced Vorgangsansicht (BOTH shells);
//   - CwMyRequestsPage      — the Consultant frame for „Meine Anträge" (shows only the ONE table
//                             „Laufende Anträge" since „nur Vorgänge", no more Reiter).
// Declared and exported HERE because their building blocks (context header, document panel) also
// come from this module and CwModule is already in both shells' graph via ConsultantCoreModule ->
// FeatureCrmModule — no new module import needed.
import {CwCaseMinePage} from "./page/object/cw-case-mine-page/cw-case-mine.page";
import {CwCaseDocumentsPage} from "./page/object/cw-case-documents-page/cw-case-documents.page";
import {CwMyRequestsPage} from "./page/consultant-page/my-requests-page/cw-my-requests.page";
// „Beratungsdokumentation" — die globale Liste aller cw.CwConsultationDoc in der Consultant-Shell
// (Route cw/consultationDocs). Wie CwMyRequestsPage eine reine Consultant-Fläche, deshalb ebenfalls
// unter page/consultant-page/; deklariert UND exportiert, weil shell-consultant die Komponente
// direkt routet.
import {
    CwConsultationDocsPage
} from "./page/consultant-page/consultation-docs-page/cw-consultation-docs.page";
import {
    CwCaseConsultantComponent
} from "./component/protected-components/cw-case-consultant/cw-case-consultant.component";
// TM-1000002000: the consultant overlay of cw.CwCase and its per-shell token (default = full Vorgang).
import {
    CwCaseConsultantOverlayComponent
} from "./component/protected-components/cw-case-consultant-overlay/cw-case-consultant-overlay.component";
import {CW_CASE_PAGE_COMPONENT} from "./service/token/cw-case.token";
import {
    CW_LOCAL_SUBMIT_RETURN_TARGET,
    CW_LOCAL_SUBMIT_RETURN_TO_CASE_WORKLIST
} from "./service/token/cw-local-submit-return.token";
import {
    CwMyRequestsComponent
} from "./component/protected-components/consultant-component/cw-my-requests/cw-my-requests.component";
// [cw_qualitaetscenter] Die drei Bereichskomponenten von cw/dashboard. Die vierte Komponente des
// Ordners, CwRequestReviewWorkbenchComponent, wird BEWUSST nicht hier deklariert, sondern von
// CwRequestModule — sie hat einen zweiten Mount-Punkt in der Consultant-Shell (Begründung dort).
import {
    CwQualityOverviewComponent
} from "./page/dashboard/cw-case-dashboard/components/cw-quality-overview/cw-quality-overview.component";
// [cw_qualitaetscenter] Bereich „Jobs" (cw/dashboard?navItem=jobs). Wird — anders als die
// Antragseingangs-Werkbank — HIER deklariert: er hat genau einen Mount-Punkt, nämlich die von
// diesem Modul deklarierte CwCaseDashboardPage, und die Consultant-Shell braucht ihn nicht.
import {
    CwJobsTabComponent
} from "./page/dashboard/cw-case-dashboard/components/cw-jobs-tab/cw-jobs-tab.component";
import {
    CwCaseReviewWorkbenchComponent
} from "./page/dashboard/cw-case-dashboard/components/cw-case-review-workbench/cw-case-review-workbench.component";
import {
    CwCaseWorkbenchDetailComponent
} from "./page/dashboard/cw-case-dashboard/components/cw-case-workbench-detail/cw-case-workbench-detail.component";
// [cw_carlo_enhancements WP-5] Bereich „Rückfragen" (cw/dashboard?navItem=inquiries). Wie
// CwCaseReviewWorkbenchComponent HIER deklariert: genau ein Mount-Punkt, die von diesem Modul
// deklarierte CwCaseDashboardPage; die Consultant-Shell braucht ihn nicht.
import {
    CwInquiryWorkbenchComponent
} from "./page/dashboard/cw-case-dashboard/components/cw-inquiry-workbench/cw-inquiry-workbench.component";
// Bereiche „Meine Aktivitäten" / „Alle Aktivitäten" (cw.CwCaseActivity; cw/dashboard?navItem=myActivities
// bzw. allActivities) — eine Komponente mit [scope], Mount-Punkt die CwCaseDashboardPage.
import {
    CwMyActivitiesComponent
} from "./page/dashboard/cw-case-dashboard/components/cw-my-activities/cw-my-activities.component";
// Bereich „Statuskorrektur (Admin)" (cw/dashboard?navItem=adminStatus, nur für admin/cw_admin). Genau ein
// Mount-Punkt, die CwCaseDashboardPage — deshalb nur deklariert, nicht exportiert.
import {
    CwAdminSubmittableRestoreComponent
} from "./page/dashboard/cw-case-dashboard/components/cw-admin-submittable-restore/cw-admin-submittable-restore.component";
// „Fehlgeschlagene Einreichungen" — the finder list above the Vorgangs-ID field of the same section; its only
// mount point is CwAdminSubmittableRestoreComponent, so declared, not exported.
import {
    CwAdminFailedSubmissionFinderComponent
} from "./page/dashboard/cw-case-dashboard/components/cw-admin-failed-submission-finder/cw-admin-failed-submission-finder.component";
// [cw-dashboard-kpi] The KPI row of the overview: one controlling component (loads
// GET /mvsa/cw/cases/dashboard/kpi) and two purely presentational ones. All three are ONLY declared
// and deliberately NOT exported: they have exactly one mount point, CwQualityOverviewComponent in
// the same folder. An export would be an invitation to mount the cards elsewhere — and so to write
// the KPI definition down a second time.
import {
    CwCaseKpiPanelComponent
} from "./page/dashboard/cw-case-dashboard/components/cw-case-kpi-panel/cw-case-kpi-panel.component";
import {
    CwCaseKpiGroupCardComponent
} from "./page/dashboard/cw-case-dashboard/components/cw-case-kpi-group-card/cw-case-kpi-group-card.component";
import {
    CwCaseKpiPartnerTileComponent
} from "./page/dashboard/cw-case-dashboard/components/cw-case-kpi-partner-tile/cw-case-kpi-partner-tile.component";
import {
    CwCaseObjectComponent
} from "./component/protected-components/cw-case-object-component/cw-case-object.component";
import {
    CwCaseTypeObjectComponent
} from "./component/protected-components/object-component/cw-case-type-object-component/cw-case-type-object.component";
// Track B2: the rebuilt standard view of the CwCaseType OBC — a coordinator that owns the left
// navigation (4 points + conditional Bipro) plus one content component per navigation point.
import {
    CwCaseTypeObjectStandardComponent
} from "./component/protected-components/object-component/cw-case-type-object-component/view/cw-case-type-object-standard/cw-case-type-object-standard.component";
import {
    CwCaseTypeOverviewComponent
} from "./component/protected-components/object-component/cw-case-type-object-component/view/overview/cw-case-type-overview.component";
import {
    CwCaseTypeBiproViewComponent
} from "./component/protected-components/object-component/cw-case-type-object-component/view/bipro/cw-case-type-bipro-view.component";
// [CW-SCHEMA] "Schema" navigation point — the read-only JSON of GET /cw/exchange/schema in CodeMirror,
// shown next to "Bipro" and under the same condition (the case type has a CwCaseTypeBipro row).
import {
    CwCaseTypeSchemaComponent
} from "./component/protected-components/object-component/cw-case-type-object-component/view/schema/cw-case-type-schema.component";
import {
    CwCaseTypeProductsComponent
} from "./component/protected-components/object-component/cw-case-type-object-component/view/products/cw-case-type-products.component";
import {
    CwCaseTypeModelingComponent
} from "./component/protected-components/object-component/cw-case-type-object-component/view/modeling/cw-case-type-modeling.component";
import {
    CwCaseTypeOthersComponent
} from "./component/protected-components/object-component/cw-case-type-object-component/view/others/cw-case-type-others.component";
// Track B2 follow-up: dedicated OBC for CwCaseTypeStep (opened right/side from the Modellierung timeline)
import {
    CwCaseTypeStepObjectComponent
} from "./component/protected-components/object-component/cw-case-type-step-object-component/cw-case-type-step-object.component";
// QuickQuote: the sister editor for CwCaseTypeQuickQuoteStep, opened from the „Quick Quote" section
// of the same Modellierung timeline.
import {
    CwCaseTypeQuickQuoteStepObjectComponent
} from "./component/protected-components/object-component/cw-case-type-quick-quote-step-object-component/cw-case-type-quick-quote-step-object.component";
// [CW-VP-DIM] Objektseite + OBC der Vorbelegung (CwCaseTypeDefault) — PO-Entscheid Q7
import {
    CwCaseTypeDefaultObjectComponent
} from "./component/protected-components/object-component/cw-case-type-default-object-component/cw-case-type-default-object.component";
import {
    CwCaseTypeDefaultObjectPage
} from "./page/object/cw-case-type-default-object-page/cw-case-type-default-object.page";
// V4 (Prüfkonzept §3.2): config-check panel rendered in the CwCaseType OBC header popover
import {
    CwCaseTypeConfigCheckPanelComponent
} from "./component/protected-components/cw-case-type-config-check-panel/cw-case-type-config-check-panel.component";
// [CW-PERSON-REFACTOR][WP-D3] Read-only panel on the CwCaseType Basisdaten tab: which of the three
// routing stages (Vorgangstyp -> CwCaseTypeTemplate -> nothing) actually answers per axis.
import {
    CwCaseTypeRoutingInheritanceComponent
} from "./component/protected-components/cw-case-type-routing-inheritance/cw-case-type-routing-inheritance.component";
import {
    CwConsultationDocTypeObjectComponent
} from "./component/protected-components/object-component/cw-consultation-doc-type-object-component/cw-consultation-doc-type-object.component";
import {
    CwConsultationDocTypeObjectBaseComponent
} from "./component/protected-components/object-component/cw-consultation-doc-type-object-component/view/cw-consultation-doc-type-object-base.component";
import {
    CwConsultationDocTypeObjectFullComponent
} from "./component/protected-components/object-component/cw-consultation-doc-type-object-component/view/cw-consultation-doc-type-object-component-full/cw-consultation-doc-type-object-full.component";
import {
    CwConsultationDocTypeObjectPage
} from "./page/object/cw-consultation-doc-type-object-page/cw-consultation-doc-type-object.page";
import {
    CwCaseTypeObjectPage
} from "./page/object/cw-case-type-object-page/cw-case-type-object.page";
import {
    CwTextBlockAiDialogComponent
} from "./component/protected-components/cw-text-block-ai-dialog/cw-text-block-ai-dialog.component";
import {
    CwConsultationSectionRendererComponent
} from "./component/cw-consultation-section-renderer/cw-consultation-section-renderer.component";
import {
    CwConsultationWorkbenchComponent
} from "./component/cw-consultation-workbench/cw-consultation-workbench.component";
// [T2 · P3] Aktionsleiste „Beratung abschließen" / „Wieder öffnen". EINE Komponente, ZWEI Hosts
// (Workbench im Erfassungsablauf + Objektseite) — deshalb hier deklariert und nicht in einem der
// beiden Hosts.
import {
    CwConsultationClosureActionsComponent
} from "./component/cw-consultation-closure-actions/cw-consultation-closure-actions.component";
import {
    CwConsultationDocObjectComponent
} from "./component/protected-components/object-component/cw-consultation-doc-object-component/cw-consultation-doc-object.component";
// Die vier Bausteine der standalone Beratungsdok-Objektseite. Sie ersetzen die generische Objektform,
// die dort ~19 Felder inkl. drei Rich-Text-Editoren gerendert hat; sie sind bewusst NICHT exportiert,
// weil sie nur innerhalb von CwConsultationDocObjectComponent montiert werden.
import {
    CwConsultationDocHeaderComponent
} from "./component/protected-components/object-component/cw-consultation-doc-object-component/shared/cw-consultation-doc-header/cw-consultation-doc-header.component";
// Der SEITENKOPF der Beratungsdok-Objektseite — NICHT Teil der Seite, sondern von <mvs-page-header>
// im Komponentenmodus gerendert (CwConsultationDocObjectPage#getPageHeaderConfig). Er traegt die
// Identitaet des Dokuments: ID, Kunde, Statuschip, Dokumenttyp.
import {
    CwConsultationDocContextHeaderComponent
} from "./component/cw-consultation-doc-context-header/cw-consultation-doc-context-header.component";
import {
    CwConsultationDocParticipantsComponent
} from "./component/protected-components/object-component/cw-consultation-doc-object-component/shared/cw-consultation-doc-participants/cw-consultation-doc-participants.component";
import {
    CwConsultationDocClosureBarComponent
} from "./component/protected-components/object-component/cw-consultation-doc-object-component/shared/cw-consultation-doc-closure-bar/cw-consultation-doc-closure-bar.component";
import {
    CwConsultationDocNotesComponent
} from "./component/protected-components/object-component/cw-consultation-doc-object-component/shared/cw-consultation-doc-notes/cw-consultation-doc-notes.component";
import {
    CwConsultationDocDeviationNoteComponent
} from "./component/protected-components/object-component/cw-consultation-doc-object-component/shared/cw-consultation-doc-deviation-note/cw-consultation-doc-deviation-note.component";
import {
    CwConsultationDocSignaturesComponent
} from "./component/protected-components/object-component/cw-consultation-doc-object-component/shared/cw-consultation-doc-signatures/cw-consultation-doc-signatures.component";
import {
    CwConsultationDocSignaturePanelComponent
} from "./component/protected-components/object-component/cw-consultation-doc-object-component/shared/cw-consultation-doc-signature-panel/cw-consultation-doc-signature-panel.component";
import {
    CwConsultationDocSignatureStepComponent
} from "./component/protected-components/object-component/cw-consultation-doc-object-component/shared/cw-consultation-doc-signature-step/cw-consultation-doc-signature-step.component";
import {
    CwConsultationDocObjectPage
} from "./page/object/cw-consultation-doc-object-page/cw-consultation-doc-object.page";
// [Beratungsdok-Redesign] Die neue Oberflaeche liegt NEBEN der bestehenden: eigene Workbench, eigene
// Objektkomponente, eigene Seite. Nichts an den drei Originalen wird angefasst — die Neugestaltung
// wird gegen die Flaeche geprueft, die sie ersetzen soll.
import {
    CwConsultationWorkbenchRedesignComponent
} from "./component/cw-consultation-workbench-redesign/cw-consultation-workbench-redesign.component";
// Die drei Teile der neugestalteten Flaeche. Kopf und Navigator liegen fest; die MITTE
// (CwConsultationRedesignDocumentComponent) ist der Austauschpunkt — ein anderes Erfassungsdesign
// ersetzt genau dieses Element und sonst nichts (siehe CwRedesignDocumentHost).
import {
    CwConsultationRedesignHeaderComponent
} from "./component/cw-consultation-workbench-redesign/shared/cw-consultation-redesign-header/cw-consultation-redesign-header.component";
import {
    CwConsultationRedesignNavComponent
} from "./component/cw-consultation-workbench-redesign/shared/cw-consultation-redesign-nav/cw-consultation-redesign-nav.component";
import {
    CwConsultationRedesignDocumentComponent
} from "./component/cw-consultation-workbench-redesign/shared/cw-consultation-redesign-document/cw-consultation-redesign-document.component";
// Der Abschnittsrumpf in der Gestalt des Prototyps — erweitert den bestehenden Renderer und ersetzt
// NUR dessen Template; Auswahl, Wiederholung, Speicherung bleiben unveraendert geerbt.
import {
    CwConsultationRedesignSectionComponent
} from "./component/cw-consultation-workbench-redesign/shared/cw-consultation-redesign-section/cw-consultation-redesign-section.component";
import {
    CwConsultationDocRedesignComponent
} from "./component/protected-components/object-component/cw-consultation-doc-redesign-component/cw-consultation-doc-redesign.component";
import {
    CwConsultationDocRedesignPage
} from "./page/object/cw-consultation-doc-redesign-page/cw-consultation-doc-redesign.page";
import {CW_ENTITY_PROVIDER} from "./cw.entity-provider";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {FeatureCrmRoutingModule} from "../feature-crm.routing.module";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {ContextMenuModule} from "primeng/contextmenu";
import {SplitterModule} from "primeng/splitter";
import {IconField} from "primeng/iconfield";
import {InputIcon} from "primeng/inputicon";
import {
    CwCaseObjectStepProductComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-product/cw-case-object-step-product.component";
import {
    CwCaseObjectStepBusinessTypeComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-business-type/cw-case-object-step-business-type.component";
// [CW-PERSON-REFACTOR][WP-D2] THE person step — one component behind the three registry keys PERSONS
// (3), PRODUCT_PERSON_ASSIGNMENT (8) and PRODUCT_PERSON_SELECTION (33). Level and capture come from
// the key, the role flavour from the free-text column cw.CwStepType.flavour.
import {
    CwCaseObjectStepPersonSelectionComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-person-selection/cw-case-object-step-person-selection.component";
// TM-1000001991: the two person questions of a case (J1 currency / J2 assignment) as one visibly
// separated surface. Needs no extra module: p-table, p-tag, p-skeleton, p-divider and p-button come
// through CoreModule -> SharedModule, <cr-customer-persons> through the CrModule import.
import {
    CwCasePersonCheckComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-person-selection/cw-case-person-check.component";
import {
    CwCaseObjectStepContractDataComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-contract-data/cw-case-object-step-contract-data.component";
import {
    CwCaseObjectStepPaymentComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-payment/cw-case-object-step-payment.component";
import {
    CwCaseObjectStepSignaturesComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-signatures/cw-case-object-step-signatures.component";
import {
    CwCaseObjectStepSummaryComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-summary/cw-case-object-step-summary.component";
import {
    CwTextBlockInserterComponent
} from "./component/protected-components/cw-case-object-component/shared/cw-text-block-inserter/cw-text-block-inserter.component";
import {
    CwTextBlockSidebarComponent
} from "./component/protected-components/cw-case-object-component/shared/cw-text-block-sidebar/cw-text-block-sidebar.component";
import {
    CwCaseObjectStepConsultationBasicsComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-consultation-basics/cw-case-object-step-consultation-basics.component";
import {
    CwCaseObjectStepConsultationSelectionsComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-consultation-selections/cw-case-object-step-consultation-selections.component";
import {
    CwCaseObjectStepConsultationDetailsComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-consultation-details/cw-case-object-step-consultation-details.component";
import {
    CwCaseObjectStepConsultationSignatureComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-consultation-signature/cw-case-object-step-consultation-signature.component";
import {ConfirmationService} from "primeng/api";
import {MvsConfirmationService} from "../../core/shared/service/confirmation/mvs-confirmation.service";
import {CmModule} from "../cm/cm.module";
// [CW-TAA-V3][B-11] For <ci-customer-insurable-objects> in the PRODUCT_OBJECT_ASSIGNMENT step. ci imports
// nothing but CoreModule, so this edge cannot close an NgModule cycle; FeatureCrmModule already imports
// both modules into the same injector, so ci's providers are registered exactly once either way.
import {CiModule} from "../ci/ci.module";
// [CW-PERSON-CONTACT-STEP] Brings cr-object-addresses and cr-object-contacts in — the two selection
// surfaces the PERSON_CONTACT_ADDRESS step uses instead of rebuilding them. cr and cw both live in
// feature-crm, and CrModule imports neither CwModule nor anything that imports it, so no module
// cycle arises.
import {CrModule} from "../cr/cr.module";
import {SmModule} from "../sm/sm.module";
import {DmModule} from "../../feature-core/dm/dm.module";
// [CW-CARLO-ENHANCEMENTS / WP-6] For <mvs-ns-notification-types-for-object> in the LOCAL_CHECK step's
// "Benachrichtigungen" block. NsModule only imports CoreModule, so this cannot close an NgModule cycle.
import {NsModule} from "../../feature-core/ns/ns.module";
import {
    CwCaseObjectStepDocumentUploadComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-document-upload/cw-case-object-step-document-upload.component";
import {
    CwCaseObjectStepCustomerSelectComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-customer-select/cw-case-object-step-customer-select.component";
import {
    CwCaseObjectStepCaseTypeComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-case-type/cw-case-object-step-case-type.component";
import {
    CwCaseObjectStepPartnerProductComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-partner-product/cw-case-object-step-partner-product.component";
import {
    CwCaseObjectStepReviewComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-review/cw-case-object-step-review.component";
import {
    CwCaseObjectStepAgentComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-agent/cw-case-object-step-agent.component";
import {
    CwCaseObjectStepAddressComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-address/cw-case-object-step-address.component";
import {
    CwCaseObjectStepGeneralAgencyNumberComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-general-agency-number/cw-case-object-step-general-agency-number.component";
import {
    CwCaseObjectStepPersonContactAddressComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-person-contact-address/cw-case-object-step-person-contact-address.component";
import {
    CwCaseObjectStepRequestPersonTakeoverComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-request-person-takeover/cw-case-object-step-request-person-takeover.component";
import {
    CwCaseObjectStepObjectTakeoverComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-object-takeover/cw-case-object-step-object-takeover.component";
import {
    CwCaseObjectStepPremiumCaptureComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-premium-capture/cw-case-object-step-premium-capture.component";
import {
    CwCaseObjectStepBillingAccountSelectionComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-billing-account-selection/cw-case-object-step-billing-account-selection.component";
import {
    CwCaseObjectStepLocalProductComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-local-product/cw-case-object-step-local-product.component";
import {
    CwCaseObjectStepLocalPersonsComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-local-persons/cw-case-object-step-local-persons.component";
import {
    CwCaseObjectStepLocalObjectsComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-local-objects/cw-case-object-step-local-objects.component";
import {
    CwCaseObjectStepLocalPersonsObjectsComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-local-persons-objects/cw-case-object-step-local-persons-objects.component";
// [CW-CT30 POLICY-WAIT] LOCAL_POLICY_WAIT — "Warte auf Police": the last step of case type 30, with
// „Eingehende Rückfragen" (ticket list + the shared Rückfragen switch) and „Versicherungsschein" (the
// Policierungs-Section in full form). Level CASE, ordinal 47 — see the registry entry.
import {
    CwCaseObjectStepLocalPolicyWaitComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-local-policy-wait/cw-case-object-step-local-policy-wait.component";
// [CW-CT30 POLICY-WAIT] The Rückfragen-Status switch as its OWN component, so „Prüfung" and „Warte auf
// Police" cannot end up with two tables of labels and two clickability matrices.
import {
    CwCaseInquiryStatusComponent
} from "./component/protected-components/cw-case-object-component/component/cw-case-inquiry-status/cw-case-inquiry-status.component";
import {
    CwCaseObjectStepLocalPriceComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-local-price/cw-case-object-step-local-price.component";
import {
    CwCaseObjectStepLocalFormerContractComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-local-former-contract/cw-case-object-step-local-former-contract.component";
import {
    CwCaseObjectStepLocalAgentsComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-local-agents/cw-case-object-step-local-agents.component";
// [CW-CASETYPE30] LOCAL_SUMMARY_SUBMIT — the closing LocalCase step. NOT the same component as the
// CwCaseObjectStepCaseSummaryComponent below (SUMMARY, which only displays) and not the ORDER step;
// see the registry entry for why none of the three can be one.
import {
    CwCaseObjectStepLocalSummarySubmitComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-local-summary-submit/cw-case-object-step-local-summary-submit.component";
// [CW-CARLO-ENHANCEMENTS / WP-6] LOCAL_CHECK — "Prüfung": Rückfragen-Status, Ticket-Anlage, Ticket-
// Liste (WP-4) und Benachrichtigungen. Level CASE, ordinal 42 — see the registry entry.
import {
    CwCaseObjectStepLocalCheckComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-local-check/cw-case-object-step-local-check.component";
// [CW-CT15-BENEFICIARIES] BENEFICIARIES (43) — "Bezugsberechtigte": the 1:n capture of the
// beneficiary entitlements of a product line. It mounts <cr-customer-persons> (through this module's
// CrModule import) and <mvs-crud-object-generic> (through CoreModule -> SharedModule); p-inputNumber,
// p-tag, p-button, p-message, p-skeleton and pTooltip come from there as well, so no additional
// module import is needed. See the registry entry.
import {
    CwCaseObjectStepBeneficiariesComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-beneficiaries/cw-case-object-step-beneficiaries.component";
// [CW-QUICK-LAUNCH] LOCAL_BASE_DATA (44) — "Basisdaten (Local)": renders TWO stacked generic forms,
// <mvs-crud-object-generic> over cw.CwCase and over cw.CwCaseProduct, plus p-skeleton / p-button — all
// reachable through CoreModule -> SharedModule, so no additional module import is needed. See the
// registry entry.
import {
    CwCaseObjectStepLocalBaseDataComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-local-base-data/cw-case-object-step-local-base-data.component";
// [CW-PRODUCT-PERSON-FIELDS] PRODUCT_PERSON_FIELDS (45) — "Produkt-Personendaten": one repeated
// pm.Person form per person of the product line, trimmed by the block's own MvsFormControlOverwrite.
// Needs no additional module import: <mvs-crud-object-generic> comes through CoreModule -> SharedModule
// and so do p-message, p-skeleton and p-button. See the registry entry.
import {
    CwCaseObjectStepProductPersonFieldsComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-product-person-fields/cw-case-object-step-product-person-fields.component";
import {
    CwCaseObjectStepPriceComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-price/cw-case-object-step-price.component";
import {
    CwCaseObjectStepHostComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-host/cw-case-object-step-host.component";
// [cw alternate display] What the step host draws instead of a step the caller may not open, and the per-shell
// target of its „Zur Vorgangsübersicht" (default = Alpha, the consultant shell overrides it).
import {
    CwCaseObjectStepAlternateDisplayComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-alternate-display/cw-case-object-step-alternate-display.component";
import {
    CW_STEP_ALTERNATE_DASHBOARD_ALPHA,
    CW_STEP_ALTERNATE_DASHBOARD_TARGET
} from "./service/token/cw-step-alternate-navigation.token";
import {
    CwCaseObjectStepConsultantDocumentationComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-consultant-documentation/cw-case-object-step-consultant-documentation.component";
import {
    CwCaseObjectStepDocumentsComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-documents/cw-case-object-step-documents.component";
import {
    CwCaseObjectStepQuestionsComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-questions/cw-case-object-step-questions.component";
import {
    CwCaseObjectStepProductDataComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-product-data/cw-case-object-step-product-data.component";
import {
    CwCaseObjectStepProductObjectAssignmentComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-product-object-assignment/cw-case-object-step-product-object-assignment.component";
import {
    CwCaseObjectStepGenericFieldsComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-generic-fields/cw-case-object-step-generic-fields.component";
import {
    CwCaseObjectStepCoveragesComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-coverages/cw-case-object-step-coverages.component";
import {
    CwCaseObjectStepPersonCoveragesComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-person-coverages/cw-case-object-step-person-coverages.component";
import {
    CwCoverageCardListComponent
} from "./component/protected-components/cw-case-object-component/step/shared/cw-coverage-card-list/cw-coverage-card-list.component";
import {
    CwDefaultProposalBarComponent
} from "./component/protected-components/cw-case-object-component/step/shared/cw-default-proposal-bar/cw-default-proposal-bar.component";
// Das Produktband — vom Schritt-Host über JEDEM produktbezogenen Schritt montiert, nicht von einer
// einzelnen Schritt-Komponente.
import {
    CwCaseProductPremiumBandComponent
} from "./component/protected-components/cw-case-object-component/step/shared/cw-case-product-premium-band/cw-case-product-premium-band.component";
// [#B.1] The delivered per-person premium shares — ONE display component for both sites (the
// Produktband of the Tarifierungsschritte and the ct15 person tab). Purely presentational.
import {
    CwCasePersonPremiumSharesComponent
} from "./component/protected-components/cw-case-object-component/step/shared/cw-case-person-premium-shares/cw-case-person-premium-shares.component";
// The ONE product overview of a case — embedded by the TARIFF_OVERVIEW, SUMMARY and OFFER steps.
// It replaces the block that stood written out five times in this tree. Needs no extra PrimeNG module:
// p-skeleton, p-button, p-message and mvs-widget all arrive via CoreModule -> SharedModule (see the
// note at the pages further down, which records the same for those three).
import {
    CwCaseProductOverviewComponent
} from "./component/protected-components/cw-case-object-component/step/shared/cw-case-product-overview/cw-case-product-overview.component";
// [CW-STEP-HEADER] The ONE step header bar — replaces the block each of the 28 step templates carried.
import {
    CwCaseObjectStepHeaderComponent
} from "./component/protected-components/cw-case-object-component/step/shared/cw-case-object-step-header/cw-case-object-step-header.component";
import {
    CwCaseObjectStepOfferComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-offer/cw-case-object-step-offer.component";
import {
    CwCaseObjectStepTariffOverviewComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-tariff-overview/cw-case-object-step-tariff-overview.component";
// [CW-SALES-ENHANCEMENT / AD-3' 3'.5] REQUEST_APPLICATION (41) — „Antrag anfordern": the step that asks
// the insurer for the Antrag and shows the document that comes back. Subclass of the DOCUMENTS step.
import {
    CwCaseObjectStepRequestApplicationComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-request-application/cw-case-object-step-request-application.component";
import {
    CwCaseObjectStepOrderComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-order/cw-case-object-step-order.component";
// [CW-TAA-V3] SUMMARY — the registry-dispatched Fall-Zusammenfassung. NOT the same component as the
// CwCaseObjectStepSummaryComponent above, which the old wizard's hardcoded branches mount and which
// submits; see the registry entry for why the two cannot be one.
import {
    CwCaseObjectStepCaseSummaryComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-case-summary/cw-case-object-step-case-summary.component";
// [CW-CONSULTATION-DOC-STEP] CONSULTATION_DOC — the PROVISIONING step in front of the four
// Beratungs-sections. Not the same component as CwCaseObjectStepConsultantDocumentationComponent
// above, which is the editing surface; see the registry entry for why the two cannot be one.
import {
    CwCaseObjectStepConsultationDocComponent
} from "./component/protected-components/cw-case-object-component/step/cw-case-object-step-consultation-doc/cw-case-object-step-consultation-doc.component";
import {CwCaseCreatePage} from "./page/object/cw-case-create-page/cw-case-create.page";
// [CW-QUICK-LAUNCH] cw/case/create/quick/:customerId/:caseTypeId — creates a QUICK_QUOTE case for one
// Vorgangstyp and mounts CwCaseQuickQuoteObjectComponent. Declared AND exported here because it is routed
// in both shells (the consultant route file imports it from this module's graph).
import {CwCaseQuickLaunchPage} from "./page/object/cw-case-quick-launch-page/cw-case-quick-launch.page";
// [CW-QUICK-LAUNCH] The ONE telephone-consent capture (TELEFON-EINWILLIGUNG of a PHONE_CALLCENTER closure),
// used by the quick-launch page; the create selection stage switches over to it as a follow-up.
import {
    CwCasePhoneConsentComponent
} from "./component/protected-components/cw-case-phone-consent/cw-case-phone-consent.component";
// [CW-QUICK-LAUNCH] The ONE Abschlussweg tile grid (icon, label, description per channel), extracted from the create
// selection stage and shared with the quick-launch page.
import {
    CwCaseChannelTilesComponent
} from "./component/protected-components/cw-case-channel-tiles/cw-case-channel-tiles.component";
// Top-down create redesign: the Segment-A selection stage and its quick-select tile row. Both are
// composed by CwCaseCreatePage; the selection stage is additionally reachable through the
// {mode: create} entry-registry mapping of cw.CwCase.
import {
    CwCaseCreateSelectionComponent
} from "./component/protected-components/cw-case-create-selection/cw-case-create-selection.component";
import {
    CwCaseQuickSelectComponent
} from "./component/protected-components/cw-case-quick-select/cw-case-quick-select.component";
// The horizontal step header of the online create: every decision already taken, left to right, plus
// the confirm actions. It replaces BOTH the collapsed summary-card stack and the bottom confirm bar
// that used to live inside the selection stage.
import {
    CwCaseCreateStepHeaderComponent
} from "./component/protected-components/cw-case-create-step-header/cw-case-create-step-header.component";
// The UNIVERSAL-Antragstyp block that sits ABOVE the tile row in the create page's side column. It
// exists because a CwCaseTypeProduct in mode UNIVERSAL carries no partner, and the selection cascade
// is partner-first — see the component's class doc.
import {
    CwCaseUniversalSelectComponent
} from "./component/protected-components/cw-case-universal-select/cw-case-universal-select.component";
// THE one-entry-per-row surface of the cw selection lists (logo left, text right). An EXTRACTION:
// cw-case-universal-select and cw-case-quick-select had copied the same geometry and said so in their
// own comments. Purely presentational — it reads nothing and decides nothing.
import {
    CwSelectRowComponent
} from "./component/protected-components/cw-select-row/cw-select-row.component";
// QuickQuote: the panel of the create route, its reusable case list and the stacked capture surface.
// The capture surface is mounted DIRECTLY by selector (like the case orchestrator), not through the
// entity registry — see its class doc.
import {
    CwCaseQuickQuotePanelComponent
} from "./component/protected-components/cw-case-quick-quote-panel/cw-case-quick-quote-panel.component";
import {
    CwCasePhaseListComponent
} from "./component/protected-components/cw-case-phase-list/cw-case-phase-list.component";
import {
    CwCaseQuickQuoteObjectComponent
} from "./component/protected-components/cw-case-quick-quote-object-component/cw-case-quick-quote-object.component";
import {
    CwCaseObjectSidebarComponent
} from "./component/protected-components/cw-case-object-component/component/cw-case-object-sidebar/cw-case-object-sidebar.component";
import {
    CwCaseObjectHeaderComponent
} from "./component/protected-components/cw-case-object-component/component/cw-case-object-header/cw-case-object-header.component";
// [cw_carlo_enhancements WP-4a] Replaces mvs-create-ticket-object as the content of the "Ticket
// erstellen" dialog on the case header — a hand-built action dialog against CwCaseTicketController,
// not entity CRUD (see the component's own TSDoc). mvs-create-ticket-object stays in place for the
// generic dm/cr/cm ticket-creation flows, so its import above is removed only here.
import {
    CwCaseTicketCreateComponent
} from "./component/protected-components/cw-case-object-component/component/cw-case-ticket-create/cw-case-ticket-create.component";
import {
    CwCaseObjectFooterComponent
} from "./component/protected-components/cw-case-object-component/component/cw-case-object-footer/cw-case-object-footer.component";
import {
    CwCaseObjectSummaryComponent
} from "./component/protected-components/cw-case-object-component/component/cw-case-object-summary/cw-case-object-summary.component";
import {
    CwCaseObjectPdfPanelComponent
} from "./component/protected-components/cw-case-object-component/component/cw-case-object-pdf-panel/cw-case-object-pdf-panel.component";
// [TM-1000002003] CwCaseDocumentPanelComponent was imported here. It is DELETED:
// mvs-cw-case-work-panel is now the ONE right-hand panel of every case surface (case page, consultant
// view), and the tabs it used to build in are contributed by those call sites instead.
// [CW-CASETYPE30 / Schnellerfassung] The right-hand work surface of a LocalCase: the generic tab
// shell, its tab directive, and the merged document view. The SHELL knows neither documents nor
// comments — the tabs are contributed by the caller (CwCaseObjectComponent) as
// <ng-template mvsCwWorkPanelTab>. All three are declared further below; the directive is the one
// whose absence does NOT show up as an error (reasoning there).
import {
    CwCaseWorkPanelComponent
} from "./component/protected-components/cw-case-object-component/component/cw-case-work-panel/cw-case-work-panel.component";
import {
    CwWorkPanelTabDirective
} from "./component/protected-components/cw-case-object-component/component/cw-case-work-panel/cw-work-panel-tab.directive";
import {
    CwCaseLocalDocumentsComponent
} from "./component/protected-components/cw-case-object-component/component/cw-case-local-documents/cw-case-local-documents.component";
import {
    CwCaseTransportPanelComponent
} from "./component/protected-components/cw-case-object-component/component/cw-case-transport-panel/cw-case-transport-panel.component";
import {
    CwCaseDocumentGenerateSectionComponent
} from "./component/protected-components/cw-case-object-component/sections/cw-case-document-generate-section/cw-case-document-generate-section.component";
import {
    CwCaseNotificationGenerateSectionComponent
} from "./component/protected-components/cw-case-object-component/sections/cw-case-notification-generate-section/cw-case-notification-generate-section.component";
// [cw_carlo_enhancements WP-4b] Ticket list of the "Tickets" extra tab — EXTRACTED from the inline
// widget build in cw-case-object.component.ts (loadExtraWidgets), not new construction.
import {
    CwCaseTicketListComponent
} from "./component/protected-components/cw-case-object-component/sections/cw-case-ticket-list/cw-case-ticket-list.component";
// TM-1000001889: Audit-Trail + Kommunikationsspur sections on the case detail.
import {
    CwCaseHistorySectionComponent
} from "./component/protected-components/cw-case-object-component/sections/cw-case-history-section/cw-case-history-section.component";
import {
    CwCasePolicyCompletionSectionComponent
} from "./component/protected-components/cw-case-object-component/sections/cw-case-policy-completion-section/cw-case-policy-completion-section.component";
// TM-1000002051: „Verträge je Produktzeile" on the case page — contracts per line + reviewer close / reopen.
import {
    CwCaseLineContractsComponent
} from "./component/protected-components/cw-case-object-component/sections/cw-case-line-contracts/cw-case-line-contracts.component";
import {
    CwCaseCommunicationSectionComponent
} from "./component/protected-components/cw-case-object-component/sections/cw-case-communication-section/cw-case-communication-section.component";
// [CW-SCHEMA] Datenvorschau section of the case detail — the case-side host of the two exchange
// previews (export model + BODY XML), gated on the same BiPRO coordinate as "Fremdanbindung".
import {
    CwCaseExchangePreviewSectionComponent
} from "./component/protected-components/cw-case-object-component/sections/cw-case-exchange-preview-section/cw-case-exchange-preview-section.component";
import {
    CwCaseContextHeaderComponent
} from "./component/protected-components/cw-case-object-component/component/cw-case-context-header/cw-case-context-header.component";
// [cw QuickQuote Storno] „Antrag stornieren" (button + dialog with the required Stornogrund) — ONE implementation,
// used by the context header and by the QuickQuote header band.
import {
    CwCaseCancelActionComponent
} from "./component/protected-components/cw-case-cancel-action/cw-case-cancel-action.component";
// The case's error surface: ONE row rendering (CwCaseFindingListComponent) shown by the context
// header's popover AND by the always-visible in-step block (CwCaseStepFindingPanelComponent).
import {
    CwCaseFindingListComponent
} from "./component/protected-components/cw-case-object-component/finding/cw-case-finding-list/cw-case-finding-list.component";
import {
    CwCaseStepFindingPanelComponent
} from "./component/protected-components/cw-case-object-component/finding/cw-case-step-finding-panel/cw-case-step-finding-panel.component";
// [#C.1 cw_sales_enhancements_round_2] An insurer value change: ONE registered detail line (field /
// Baustein / person / from-to), rendered under the message in the error surface AND inside the
// Produktband's hint. Plus that hint itself — the provisional-premium statement of C-Q4.
import {
    CwCaseFieldEventLineComponent
} from "./component/protected-components/cw-case-object-component/field-event/cw-case-field-event-line/cw-case-field-event-line.component";
import {
    CwCasePremiumProvisionalHintComponent
} from "./component/protected-components/cw-case-object-component/field-event/cw-case-premium-provisional-hint/cw-case-premium-provisional-hint.component";
// [#C.1 cw_sales_enhancements_round_2] Der Geltungsbereichs-Marker EINER Traegerzeile
// („Vorgangstyp" vs. „Partei-Version"), gerendert als #cust_-Spalte in BEIDEN Vereinigungstabellen
// des Antragstyps (Bipro > Echo-Regeln, Weitere > Meldungs-Mapping) — registrierte Komponente statt
// zweier kopierter Templates, gleiche Begruendung wie bei CwCaseFieldEventLineComponent.
import {
    CwCarrierScopeBadgeComponent
} from "./component/protected-components/object-component/cw-case-type-object-component/shared/cw-carrier-scope-badge/cw-carrier-scope-badge.component";
import {
    CwCaseInlineComponent
} from "./component/protected-components/cw-case-inline-component/cw-case-inline-component";
import {
    CwCaseFieldHintComponent
} from "./component/protected-components/cw-case-object-component/shared/cw-case-field-hint/cw-case-field-hint.component";
// [CW-SALES-ENHANCEMENT / AD-3' 3'.6] The ONE operation-status panel, mounted by the three
// Rechenschritte (Tarifübersicht, Angebot, Antrag anfordern).
import {
    CwCaseStepOperationStatusComponent
} from "./component/protected-components/cw-case-object-component/shared/cw-case-step-operation-status/cw-case-step-operation-status.component";
import {
    CwCaseHelpBoxComponent
} from "./component/protected-components/cw-case-object-component/shared/cw-case-help-box/cw-case-help-box.component";
// --- M2-WP4 Exchange/External-Operation runtime + config-UI (wp4-fe-spec.md slice B/C) ---
import {
    CwResolveSubmissionDialogComponent
} from "./component/cw-resolve-submission-dialog/cw-resolve-submission-dialog.component";
// [cw step audit, Stufe 9.1] Freigabe-Gate: shared between the case context header and the review
// page, because the four-eyes rule puts the decider on a different surface than the requester.
import {
    CwCaseApprovalIndicatorComponent
} from "./component/cw-case-approval-indicator/cw-case-approval-indicator.component";
import {
    CwExchangeConfigCheckPanelComponent
} from "./component/protected-components/cw-exchange-config-check-panel/cw-exchange-config-check-panel.component";
import {
    CwExchangeRenderPreviewPanelComponent
} from "./component/protected-components/cw-exchange-render-preview-panel/cw-exchange-render-preview-panel.component";
// [T3 · Antragseingang] Sub-module that DECLARES and EXPORTS CwRequestCapturePage /
// CwRequestReviewPage / CwRequestMinePage plus their capture + detail-panel surface. Importing it
// is what makes the 'cw/request/*' routes in cw.route.ts resolvable from the alpha shell; the
// consultant shell imports the same module directly. A component may only be declared once, so
// CwModule must NOT re-declare those classes below.
import {CwRequestModule} from "./component/protected-components/cw-request-shared/cw-request.module";
// [T3 · P1] Antragstyp (cw.CwRequestType) ist eine KOMPLEXE Konfigurationsentitaet (drei 1:n-Kinder)
// und bekommt deshalb nach CONFIG-003 eine eigene Objektseite mit ObjectComponent statt eines
// Inline-Master-Details auf der Config-Seite. BEWUSST hier und NICHT in CwRequestModule: dieses
// Modul liefert der Consultant-Shell genau die Beraterflaeche — die Antragstyp-Konfiguration ist
// Backoffice/Admin und hat dort nichts zu suchen (03-anschluss-t3.md P1 §4).
import {
    CwRequestTypeObjectPage
} from "./page/object/cw-request-type-object-page/cw-request-type-object.page";
import {
    CwRequestTypeObjectComponent
} from "./component/protected-components/object-component/cw-request-type-object-component/cw-request-type-object.component";

@NgModule({
    imports: [
        CoreModule,
        FeatureCrmRoutingModule,
        ConfirmDialogModule,
        // @ticket TM-1000002003: <p-contextMenu> for the manual escape hatch back to „Speichern" on the
        // five embedded generic forms of a Beratungsdokumentation (see
        // cw-consultation-action-bar-reveal.util.ts). Imported HERE and not relied on through
        // CoreModule → SharedModule: SharedModule has ContextMenuModule in its `imports` but NOT in its
        // `exports`, so it does not reach a consumer — which is why te.module.ts and dm.module.ts each
        // import it themselves. MEASURED, not assumed.
        ContextMenuModule,
        SplitterModule,
        IconField,
        InputIcon,
        CmModule,
        CiModule,
        // [CW-PERSON-CONTACT-STEP] Here only for cr-object-addresses / cr-object-contacts in the
        // PERSON_CONTACT_ADDRESS step. Both are NgModule components (standalone: false), so there is
        // no way to import them individually.
        CrModule,
        SmModule,
        DmModule,
        NsModule,
        CwRequestModule,
    ],
    declarations: [
        // Track B1: Object Page shell for the cw.CwCaseType deep-link (objectRoute cw/cwCaseType/:id)
        CwCaseTypeObjectPage,
        CwConfigPage,
        CwCaseDashboardPage,
        CwCaseObjectPage,
        // TM-1000002000: „Meine Vorgänge" (cw/case/mine), the reduced Vorgangsansicht
        // (cw/case/:id/documents) and the Consultant frame for „Meine Anträge" (ONE table since
        // „nur Vorgänge", no more Reiter), plus the two components that mount it. They need no
        // additional PrimeNG module: p-skeleton, p-button and mvs-widget come via CoreModule ->
        // SharedModule; the context header and the document panel are building blocks of THIS
        // module (further below). The former draft-counter Reiter with its p-badge/pTooltip is gone
        // with TM-1000002000 (BR-2); the new counter badge lives in the Consultant shell's menu
        // (CwCaseUncapturedCountService), not in this component group.
        CwCaseMinePage,
        CwCaseDocumentsPage,
        CwCaseConsultantComponent,
        CwCaseConsultantOverlayComponent,
        CwMyRequestsPage,
        CwConsultationDocsPage,
        CwMyRequestsComponent,
        // [cw_qualitaetscenter · E3] CwCaseReviewDashboardPage (cw/review) und CwCaseReviewPage
        // (cw/review/:id) sind abgelöst und gelöscht; ihre Fähigkeiten wurden zuvor überführt
        // (E5-Landungen: „Nochmals prüfen" + „Einreichung klären" in den Werkbank-Detailbereich,
        // „Fehlergrund" als Worklist-Spalte, „Auswertung je Vermittler" in die Übersicht).
        // Beide Adressen leben als Redirects in cw.route.ts weiter.
        //
        // Die drei Bereichskomponenten des Qualitätscenters. Alle benötigten PrimeNG-Module kommen
        // bereits über CoreModule → SharedModule; CwCaseCommunicationSectionComponent und
        // CwResolveSubmissionDialogComponent (beide im Werkbank-Detailbereich gemountet) werden
        // weiter unten von DIESEM Modul deklariert und exportiert. Es ist deshalb kein zusätzlicher
        // Modul-Import nötig.
        CwQualityOverviewComponent,
        // [cw-dashboard-kpi] The KPI row of the overview. Declared only, NOT exported (see the import
        // comment). No additional PrimeNG module needed: p-skeleton, p-message, p-toggleSwitch,
        // pTooltip and FormsModule all arrive through CoreModule → SharedModule.
        CwCaseKpiPanelComponent,
        CwCaseKpiGroupCardComponent,
        CwCaseKpiPartnerTileComponent,
        // [cw_qualitaetscenter] Bereich „Jobs". Braucht kein zusätzliches PrimeNG-Modul: p-button,
        // p-tag, p-skeleton, pTooltip, mvs-widget und das Eingabefeld der gezielten Verarbeitung
        // (mvs-form-field-text-field) kommen über CoreModule → SharedModule, p-confirmDialog über
        // den ConfirmDialogModule-Import dieses Moduls (oben).
        CwJobsTabComponent,
        CwCaseReviewWorkbenchComponent,
        CwCaseWorkbenchDetailComponent,
        CwInquiryWorkbenchComponent,
        CwMyActivitiesComponent,
        // Bereich „Statuskorrektur (Admin)". Kein zusätzliches PrimeNG-Modul: p-inputNumber, p-select,
        // p-checkbox, pTextarea, p-table, p-tag, p-message und p-skeleton kommen über CoreModule →
        // SharedModule, p-confirmDialog über den ConfirmDialogModule-Import dieses Moduls.
        CwAdminSubmittableRestoreComponent,
        // „Fehlgeschlagene Einreichungen": p-datePicker, p-multiSelect, p-toggleSwitch, pTooltip and <mvs-widget>
        // (with mvs-widget-custom-field-directive) come through CoreModule → SharedModule as well.
        CwAdminFailedSubmissionFinderComponent,
        CwCaseObjectComponent,
        CwCaseTypeObjectComponent,
        // Track B2: rebuilt standard view (coordinator + one component per navigation point)
        CwCaseTypeObjectStandardComponent,
        CwCaseTypeOverviewComponent,
        CwCaseTypeBiproViewComponent,
        // [CW-SCHEMA] read-only schema JSON of the case type
        CwCaseTypeSchemaComponent,
        CwCaseTypeProductsComponent,
        CwCaseTypeModelingComponent,
        CwCaseTypeOthersComponent,
        CwCaseTypeStepObjectComponent,
        CwCaseTypeQuickQuoteStepObjectComponent,
        // [CW-VP-DIM] Vorbelegung (CwCaseTypeDefault): Objektseiten-Shell + OBC
        CwCaseTypeDefaultObjectPage,
        CwCaseTypeDefaultObjectComponent,
        // [T3 · P1] Antragstyp: Objektseiten-Shell + OBC. Route 'cw/cwRequestType/:id' und der
        // objectComponent-Eintrag in cw-request.entity-provider.ts gehoeren in DENSELBEN Commit —
        // mit nur einem von beiden laedt die Seite leer, ohne Fehlermeldung.
        CwRequestTypeObjectPage,
        CwRequestTypeObjectComponent,
        CwCaseTypeConfigCheckPanelComponent,
        CwCaseTypeRoutingInheritanceComponent,
        CwConsultationDocTypeObjectComponent,
        CwConsultationDocTypeObjectBaseComponent,
        CwConsultationDocTypeObjectFullComponent,
        CwConsultationDocTypeObjectPage,
        CwTextBlockAiDialogComponent,
        CwCaseObjectStepProductComponent,
        CwCaseObjectStepBusinessTypeComponent,
        CwCaseObjectStepPersonSelectionComponent,
        // TM-1000001991: J1 "Aktualitaet" (incl. the S16 customer-binding finding) + J2 "Zuordnung".
        // NOT MOUNTED ANYWHERE at the moment: its former host CwCaseObjectStepPersonsComponent was
        // merged away by the cw person refactor (CUT 1). Declared and exported so a host can render
        // it again once one is chosen - see cr-customer-external-persons for the source-independent
        // successor of its J2 half.
        CwCasePersonCheckComponent,
        CwCaseObjectStepContractDataComponent,
        CwCaseObjectStepPaymentComponent,
        CwCaseObjectStepSignaturesComponent,
        CwCaseObjectStepSummaryComponent,
        CwTextBlockInserterComponent,
        CwTextBlockSidebarComponent,
        CwCaseObjectStepConsultationBasicsComponent,
        CwCaseObjectStepConsultationSelectionsComponent,
        CwCaseObjectStepConsultationDetailsComponent,
        CwCaseObjectStepConsultationSignatureComponent,
        CwCaseObjectStepDocumentUploadComponent,
        CwCaseObjectStepCustomerSelectComponent,
        CwCaseObjectStepCaseTypeComponent,
        CwCaseObjectStepPartnerProductComponent,
        CwCaseObjectStepReviewComponent,
        CwCaseObjectStepAgentComponent,
        CwCaseObjectStepAddressComponent,
        // [CW-GENERAL-AGENCY-NUMBER] GENERAL_AGENCY_NUMBER: the Vermittlernummer the case is
        // submitted under, picked from the case type's cw.CwCaseTypeGeneralAgencyNumber whitelist.
        CwCaseObjectStepGeneralAgencyNumberComponent,
        // [CW-PERSON-CONTACT-STEP] PERSON_CONTACT_ADDRESS: the address and contact data of every
        // cw.CwCasePerson, captured through cr-object-addresses / cr-object-contacts (via CrModule).
        CwCaseObjectStepPersonContactAddressComponent,
        // [CW-REQUEST-ENHANCEMENTS][WP-05/E-014] REQUEST_PERSON_TAKEOVER: the persons a document
        // reader found in the Antragseingang, taken over into the Vorgang. The person is CREATED
        // through the reused cm-create-insurable-object-person-relation-person component (D-14),
        // which reaches this module through the CmModule import above.
        CwCaseObjectStepRequestPersonTakeoverComponent,
        // [CW-REQUEST-ENHANCEMENTS][WP-06/E-016] OBJECT_TAKEOVER: the risk objects a document
        // reader found in the Antragseingang, taken over into the Vorgang. The object is CREATED
        // through the reused ci-customer-insurable-object-create component (D-16), which reaches
        // this module through the CiModule import above.
        CwCaseObjectStepObjectTakeoverComponent,
        // [CW-REQUEST-ENHANCEMENTS][WP-10/E-039] PREMIUM_CAPTURE: the Beitrag of one product line,
        // captured and validated. A component of its own rather than a re-purposed TARIFF_OVERVIEW —
        // that one is the step of the TAA streets and stays untouched (C-13).
        CwCaseObjectStepPremiumCaptureComponent,
        // [CW-REQUEST-ENHANCEMENTS][WP-10/E-043] BILLING_ACCOUNT_SELECTION: which
        // bm.CustomerBillingAccount an Eigeninkasso case collects from. It stands NEXT TO the PAYMENT
        // step (Zahlweg/SEPA), never in its place (C-14).
        CwCaseObjectStepBillingAccountSelectionComponent,
        // [CW-LOCAL-CASES / Phase B] The six LocalCase step components (ordinals 34-39). Each is a
        // DELIBERATE COPY of the TAA-street step it is modelled on, never a second key onto it —
        // signed decision FD-B1, so a LocalCase requirement cannot break a TAA street. The accepted
        // price is double maintenance; see CW_CASE_OBJECT_STEP_REGISTRY for the whole reasoning.
        CwCaseObjectStepLocalProductComponent,
        CwCaseObjectStepLocalPersonsComponent,
        CwCaseObjectStepLocalObjectsComponent,
        // [CW-CT30 PERSONS+OBJECTS] „Personen & Objekte": the registry maps LOCAL_PERSONS_OBJECTS (46) onto it.
        CwCaseObjectStepLocalPersonsObjectsComponent,
        // [CW-CT30 POLICY-WAIT] „Warte auf Police": the registry maps LOCAL_POLICY_WAIT (47) onto it.
        // MANDATORY — every step component is standalone:false, so without this entry the step host's
        // anchor.createComponent(type) throws at runtime.
        CwCaseObjectStepLocalPolicyWaitComponent,
        CwCaseObjectStepLocalPriceComponent,
        CwCaseObjectStepLocalFormerContractComponent,
        CwCaseObjectStepLocalAgentsComponent,
        // [CW-CASETYPE30] LOCAL_SUMMARY_SUBMIT: the closing LocalCase step — it summarises the Vorgang
        // and its transition submits him. It renders no submit button of its own; "Weiter" IS the act.
        CwCaseObjectStepLocalSummarySubmitComponent,
        // [CW-CARLO-ENHANCEMENTS / WP-6] LOCAL_CHECK (42): the Rückfragen tooling step — status
        // select (this step's only payload), ticket creation and list (WP-4), notifications.
        CwCaseObjectStepLocalCheckComponent,
        // [CW-CT15-BENEFICIARIES] BENEFICIARIES (43): the beneficiary capture per insured person.
        // MANDATORY — every step component is standalone:false, so without this entry the step host's
        // anchor.createComponent(type) throws at runtime.
        CwCaseObjectStepBeneficiariesComponent,
        // [CW-QUICK-LAUNCH] LOCAL_BASE_DATA (44): the Basisdaten of a LocalCase from TWO stacked generic
        // forms (cw.CwCase + cw.CwCaseProduct). MANDATORY — every step component is standalone:false, so without this entry
        // the step host's anchor.createComponent(type) throws at runtime. Not exported: it is mounted
        // through CW_CASE_OBJECT_STEP_REGISTRY only, never by selector from another module.
        CwCaseObjectStepLocalBaseDataComponent,
        // [CW-PRODUCT-PERSON-FIELDS] PRODUCT_PERSON_FIELDS (45): the per-person pm.Person capture of
        // one product line. MANDATORY for the same reason as the entry above — the step host mounts
        // it with anchor.createComponent(type), which throws for an undeclared component.
        CwCaseObjectStepProductPersonFieldsComponent,
        CwCaseObjectStepPriceComponent,
        // The ONE step host: resolves a step component from CW_CASE_OBJECT_STEP_REGISTRY, and mounts
        // the Produktband above every product-scoped step.
        CwCaseObjectStepHostComponent,
        // [cw alternate display] Drawn by the step host's template in place of a step the caller may not open.
        // Declared, not exported: its one mount point is that template, which this module compiles.
        CwCaseObjectStepAlternateDisplayComponent,
        CwCaseProductPremiumBandComponent,
        // [#B.1] The per-person premium shares — used by the Produktband AND the ct15 person step.
        CwCasePersonPremiumSharesComponent,
        // The shared product overview (TARIFF_OVERVIEW, SUMMARY, OFFER).
        CwCaseProductOverviewComponent,
        // [CW-STEP-HEADER] The ONE step header bar, mounted by the step templates themselves.
        CwCaseObjectStepHeaderComponent,
        // CONSULTANT_DOCUMENTATION: one step composing the four Beratungs-sections.
        CwCaseObjectStepConsultantDocumentationComponent,
        // [CW-CONSULTATION-DOC-STEP] CONSULTATION_DOC: the option select that PROVIDES the
        // Beratungsdokumentation — it stands in front of the step above, it does not replace it.
        CwCaseObjectStepConsultationDocComponent,
        CwCaseObjectStepDocumentsComponent,
        CwCaseObjectStepQuestionsComponent,
        CwCaseObjectStepProductDataComponent,
        CwCaseObjectStepProductObjectAssignmentComponent,
        CwCaseObjectStepGenericFieldsComponent,
        CwCaseObjectStepCoveragesComponent,
        // [CW-VP-DIM] PERSON_COVERAGES + the shared building blocks its Bausteine and its
        // proposal bar are made of (the COVERAGES step mounts the card list too, but NOT the bar —
        // the bar is PERSON_COVERAGES-only).
        //
        // [CW-TABLE·E-5] The TABLE rendering that stood beside the card list is GONE — deleted with
        // the tile swap, on the user's decision, after it had lost its last mounting point. Both
        // steps render CwCoverageCardListComponent now. It needs no extra PrimeNG import: p-checkbox,
        // p-select and p-inputNumber all arrive via CoreModule → SharedModule.
        CwCaseObjectStepPersonCoveragesComponent,
        CwCoverageCardListComponent,
        CwDefaultProposalBarComponent,
        CwCaseObjectStepOfferComponent,
        CwCaseObjectStepTariffOverviewComponent,
        CwCaseObjectStepRequestApplicationComponent,
        CwCaseObjectStepOrderComponent,
        // [CW-TAA-V3] SUMMARY
        CwCaseObjectStepCaseSummaryComponent,
        CwCaseCreatePage,
        // [CW-QUICK-LAUNCH]
        CwCaseQuickLaunchPage,
        CwCasePhoneConsentComponent,
        CwCaseChannelTilesComponent,
        CwCaseCreateSelectionComponent,
        CwCaseCreateStepHeaderComponent,
        CwCaseQuickSelectComponent,
        CwCaseUniversalSelectComponent,
        // The shared selection ROW. Needs no additional module import: <mvs-icon> arrives through
        // CoreModule -> SharedModule, the same way cw-case-universal-select already reaches it.
        CwSelectRowComponent,
        CwCaseQuickQuotePanelComponent,
        CwCasePhaseListComponent,
        CwCaseQuickQuoteObjectComponent,
        CwCaseObjectSidebarComponent,
        CwCaseObjectHeaderComponent,
        CwCaseTicketCreateComponent,
        CwCaseObjectFooterComponent,
        CwCaseObjectSummaryComponent,
        CwCaseObjectPdfPanelComponent,
        // [CW-CASETYPE30 / TM-1000002003] The right-hand work surface of EVERY case type. THE DIRECTIVE
        // IS MANDATORY and not a formality: the tabs are contributed as <ng-template mvsCwWorkPanelTab>,
        // and an undeclared attribute is, for Angular, simply an unknown attribute on an ng-template —
        // there is NO error, the ContentChildren query stays empty and the panel renders its empty state
        // ("Für diesen Bereich sind keine Inhalte verfügbar."). The tabs thus vanish silently. This trio
        // needs no additional module imports: p-tabs/p-tab come through CoreModule → SharedModule (the
        // chain the deleted CwCaseDocumentPanelComponent used to ride), p-badge as with
        // CwCaseObjectSidebarComponent, p-dialog/p-skeleton/p-button/pTooltip likewise, <mvs-dm-upload>
        // and <mvs-dm-pdf-viewer> via this module's DmModule import, and
        // <mvs-cw-case-object-pdf-panel> from this declarations list itself.
        CwCaseWorkPanelComponent,
        CwWorkPanelTabDirective,
        CwCaseLocalDocumentsComponent,
        CwCaseTransportPanelComponent,
        CwCaseDocumentGenerateSectionComponent,
        CwCaseNotificationGenerateSectionComponent,
        CwCaseTicketListComponent,
        // [CW-CT30 POLICY-WAIT] The shared Rückfragen-Status switch — mounted by „Warte auf Police"
        // today, and the one place the four buttons and their clickability live.
        CwCaseInquiryStatusComponent,
        CwCaseHistorySectionComponent,
        CwCasePolicyCompletionSectionComponent,
        // TM-1000002051: p-table, p-tag, p-message, p-skeleton, p-button and pTooltip arrive through
        // CoreModule → SharedModule; the confirm goes to the one global <p-confirmDialog>.
        CwCaseLineContractsComponent,
        CwCaseCommunicationSectionComponent,
        // [CW-SCHEMA] Datenvorschau (Export-Modell + BODY-XML) am offenen Vorgang
        CwCaseExchangePreviewSectionComponent,
        CwCaseContextHeaderComponent,
        CwCaseCancelActionComponent,
        CwCaseFindingListComponent,
        CwCaseStepFindingPanelComponent,
        CwCaseFieldEventLineComponent,
        CwCasePremiumProvisionalHintComponent,
        CwCarrierScopeBadgeComponent,
        CwCaseInlineComponent,
        CwCaseFieldHintComponent,
        CwCaseStepOperationStatusComponent,
        CwCaseHelpBoxComponent,
        // --- M2-WP4 Exchange/External-Operation runtime + config-UI ---
        CwResolveSubmissionDialogComponent,
        CwCaseApprovalIndicatorComponent,
        CwExchangeConfigCheckPanelComponent,
        CwExchangeRenderPreviewPanelComponent,
        // Beratungsdokumentation: generic section renderer + workbench host + object component
        CwConsultationSectionRendererComponent,
        CwConsultationWorkbenchComponent,
        // [T2 · P3] Abschluss-/Wiederoeffnen-Aktionsleiste, von der Workbench UND der Objektseite
        // montiert.
        CwConsultationClosureActionsComponent,
        CwConsultationDocObjectComponent,
        // Bausteine der standalone Objektseite: schlanker Kopfbereich, Teilnehmer-Chipzeile,
        // dokument-adressierte Abschlussleiste und der zugeklappte Notiz-/Technikblock am Seitenende.
        CwConsultationDocHeaderComponent,
        // Die Kontextleiste der Beratungsdokumentation. Nur deklariert, nicht exportiert: sie wird
        // ausschliesslich von CwConsultationDocObjectComponent gerendert — demselben Modul — und nie in
        // einem fremden Template referenziert.
        // @ticket TM-1000002003 — frueher dynamisch von <mvs-page-header> erzeugt; siehe die Klassendoku
        // dort, warum die Leiste jetzt dem Objekt und nicht der Route gehoert.
        CwConsultationDocContextHeaderComponent,
        CwConsultationDocParticipantsComponent,
        CwConsultationDocClosureBarComponent,
        CwConsultationDocNotesComponent,
        // Die Abweichungsbegründung — INLINE im Erfassungsbereich, nicht im Panel: sie wird während des
        // Gesprächs zur Pflicht und blockiert den Abschluss.
        CwConsultationDocDeviationNoteComponent,
        // Unterschriftenblock (AK-V-03 Teil 2), read-only — wird auch leer angezeigt.
        CwConsultationDocSignaturesComponent,
        // Vor-Ort-Unterschrift über den sm-Signaturprozess: ein Panel, vier Zweige, ein Read. Von der
        // Wizard-Sektion UND der Standalone-Dokumentseite gemountet, damit der Modus-Zweig nur einmal
        // geschrieben ist. <mvs-sm-signing-flow> kommt über den SmModule-Import dieses Moduls.
        CwConsultationDocSignaturePanelComponent,
        // @ticket TM-1000002003 — Der Unterschritt „Unterschrift" ALS BEREICH DES CONTENT-AREA.
        // Ersetzt den body-appended p-dialog (100vw/100dvh), der die gesamte Shell verdeckt hat.
        // Wird von der Capture-Surface in dem Pane gemountet, das sonst das Dokument hält.
        CwConsultationDocSignatureStepComponent,
        // [T2 · FE-19] Routed shell of the standalone Beratungsdokumentation
        // (cw/cwConsultationDoc/:id) — hosts CwConsultationDocObjectComponent.
        CwConsultationDocObjectPage,
        // [Beratungsdok-Redesign] Die neugestaltete Flaeche unter cw/cwConsultationDocRedesign/:id.
        // Drei Klassen, die ihre Originale ERWEITERN und nur das Template ersetzen.
        CwConsultationWorkbenchRedesignComponent,
        CwConsultationRedesignHeaderComponent,
        CwConsultationRedesignNavComponent,
        CwConsultationRedesignDocumentComponent,
        CwConsultationRedesignSectionComponent,
        CwConsultationDocRedesignComponent,
        CwConsultationDocRedesignPage,
    ],
    exports: [
        CwCaseTypeObjectPage,
        CwConfigPage,
        CwCaseDashboardPage,
        CwCaseObjectPage,
        // TM-1000002000: exported like the rest of the cw inventory — the Consultant shell reaches
        // this module via ConsultantCoreModule -> FeatureCrmModule and thereby gets the pages of
        // its own routes (cw/case/:id/documents, cw/request/mine) without a new module import.
        CwCaseMinePage,
        CwCaseDocumentsPage,
        CwCaseConsultantComponent,
        CwMyRequestsPage,
        CwConsultationDocsPage,
        CwMyRequestsComponent,
        // Die Bereichskomponenten werden mit exportiert, damit sie derselben Regel folgen wie der
        // übrige cw-Bestand (eine Shell, die CwModule importiert, bekommt die ganze Fläche).
        CwQualityOverviewComponent,
        CwJobsTabComponent,
        CwCaseReviewWorkbenchComponent,
        CwCaseWorkbenchDetailComponent,
        CwInquiryWorkbenchComponent,
        CwCaseObjectComponent,
        CwCaseTypeObjectComponent,
        CwCaseTypeObjectStandardComponent,
        CwCaseTypeStepObjectComponent,
        CwCaseTypeQuickQuoteStepObjectComponent,
        // [CW-VP-DIM] Vorbelegung (CwCaseTypeDefault): Objektseiten-Shell + OBC
        CwCaseTypeDefaultObjectPage,
        CwCaseTypeDefaultObjectComponent,
        // [T3 · P1] Antragstyp: Objektseiten-Shell + OBC
        CwRequestTypeObjectPage,
        CwRequestTypeObjectComponent,
        CwConsultationDocTypeObjectComponent,
        CwConsultationDocTypeObjectBaseComponent,
        CwConsultationDocTypeObjectFullComponent,
        CwConsultationDocTypeObjectPage,
        CwTextBlockAiDialogComponent,
        CwCaseObjectStepProductComponent,
        CwCaseObjectStepBusinessTypeComponent,
        CwCaseObjectStepPersonSelectionComponent,
        // TM-1000001991: J1 "Aktualitaet" (incl. the S16 customer-binding finding) + J2 "Zuordnung".
        // NOT MOUNTED ANYWHERE at the moment: its former host CwCaseObjectStepPersonsComponent was
        // merged away by the cw person refactor (CUT 1). Declared and exported so a host can render
        // it again once one is chosen - see cr-customer-external-persons for the source-independent
        // successor of its J2 half.
        CwCasePersonCheckComponent,
        CwCaseObjectStepContractDataComponent,
        CwCaseObjectStepPaymentComponent,
        CwCaseObjectStepSignaturesComponent,
        CwCaseObjectStepSummaryComponent,
        CwTextBlockInserterComponent,
        CwTextBlockSidebarComponent,
        CwCaseObjectStepConsultationBasicsComponent,
        CwCaseObjectStepConsultationSelectionsComponent,
        CwCaseObjectStepConsultationDetailsComponent,
        CwCaseObjectStepConsultationSignatureComponent,
        CwCaseObjectStepDocumentUploadComponent,
        CwCaseObjectStepCustomerSelectComponent,
        CwCaseObjectStepCaseTypeComponent,
        CwCaseObjectStepPartnerProductComponent,
        CwCaseObjectStepReviewComponent,
        CwCaseObjectStepAgentComponent,
        CwCaseObjectStepAddressComponent,
        // [CW-GENERAL-AGENCY-NUMBER] GENERAL_AGENCY_NUMBER: the Vermittlernummer the case is
        // submitted under, picked from the case type's cw.CwCaseTypeGeneralAgencyNumber whitelist.
        CwCaseObjectStepGeneralAgencyNumberComponent,
        // [CW-PERSON-CONTACT-STEP] PERSON_CONTACT_ADDRESS: the address and contact data of every
        // cw.CwCasePerson, captured through cr-object-addresses / cr-object-contacts (via CrModule).
        CwCaseObjectStepPersonContactAddressComponent,
        // [CW-REQUEST-ENHANCEMENTS][WP-05/E-014] REQUEST_PERSON_TAKEOVER: the persons a document
        // reader found in the Antragseingang, taken over into the Vorgang. The person is CREATED
        // through the reused cm-create-insurable-object-person-relation-person component (D-14),
        // which reaches this module through the CmModule import above.
        CwCaseObjectStepRequestPersonTakeoverComponent,
        // [CW-REQUEST-ENHANCEMENTS][WP-06/E-016] OBJECT_TAKEOVER: the risk objects a document
        // reader found in the Antragseingang, taken over into the Vorgang. The object is CREATED
        // through the reused ci-customer-insurable-object-create component (D-16), which reaches
        // this module through the CiModule import above.
        CwCaseObjectStepObjectTakeoverComponent,
        // [CW-REQUEST-ENHANCEMENTS][WP-10/E-039] PREMIUM_CAPTURE: the Beitrag of one product line,
        // captured and validated. A component of its own rather than a re-purposed TARIFF_OVERVIEW —
        // that one is the step of the TAA streets and stays untouched (C-13).
        CwCaseObjectStepPremiumCaptureComponent,
        // [CW-REQUEST-ENHANCEMENTS][WP-10/E-043] BILLING_ACCOUNT_SELECTION: which
        // bm.CustomerBillingAccount an Eigeninkasso case collects from. It stands NEXT TO the PAYMENT
        // step (Zahlweg/SEPA), never in its place (C-14).
        CwCaseObjectStepBillingAccountSelectionComponent,
        // [CW-LOCAL-CASES / Phase B] The six LocalCase step components (ordinals 34-39). Each is a
        // DELIBERATE COPY of the TAA-street step it is modelled on, never a second key onto it —
        // signed decision FD-B1, so a LocalCase requirement cannot break a TAA street. The accepted
        // price is double maintenance; see CW_CASE_OBJECT_STEP_REGISTRY for the whole reasoning.
        CwCaseObjectStepLocalProductComponent,
        CwCaseObjectStepLocalPersonsComponent,
        CwCaseObjectStepLocalObjectsComponent,
        // [CW-CT30 PERSONS+OBJECTS] „Personen & Objekte": the registry maps LOCAL_PERSONS_OBJECTS (46) onto it.
        CwCaseObjectStepLocalPersonsObjectsComponent,
        // [CW-CT30 POLICY-WAIT] „Warte auf Police": the registry maps LOCAL_POLICY_WAIT (47) onto it.
        // MANDATORY — every step component is standalone:false, so without this entry the step host's
        // anchor.createComponent(type) throws at runtime.
        CwCaseObjectStepLocalPolicyWaitComponent,
        CwCaseObjectStepLocalPriceComponent,
        CwCaseObjectStepLocalFormerContractComponent,
        CwCaseObjectStepLocalAgentsComponent,
        // [CW-CASETYPE30] LOCAL_SUMMARY_SUBMIT: the closing LocalCase step — it summarises the Vorgang
        // and its transition submits him. It renders no submit button of its own; "Weiter" IS the act.
        CwCaseObjectStepLocalSummarySubmitComponent,
        // [CW-CARLO-ENHANCEMENTS / WP-6] LOCAL_CHECK (42): the Rückfragen tooling step — status
        // select (this step's only payload), ticket creation and list (WP-4), notifications.
        CwCaseObjectStepLocalCheckComponent,
        // [CW-CT15-BENEFICIARIES] BENEFICIARIES (43): the beneficiary capture per insured person.
        // MANDATORY — every step component is standalone:false, so without this entry the step host's
        // anchor.createComponent(type) throws at runtime.
        CwCaseObjectStepBeneficiariesComponent,
        // [CW-PRODUCT-PERSON-FIELDS] PRODUCT_PERSON_FIELDS (45): the per-person pm.Person capture of
        // one product line. MANDATORY for the same reason as the entry above — the step host mounts
        // it with anchor.createComponent(type), which throws for an undeclared component.
        CwCaseObjectStepProductPersonFieldsComponent,
        CwCaseObjectStepPriceComponent,
        // The ONE step host: resolves a step component from CW_CASE_OBJECT_STEP_REGISTRY, and mounts
        // the Produktband above every product-scoped step.
        CwCaseObjectStepHostComponent,
        CwCaseProductPremiumBandComponent,
        // [#B.1] The per-person premium shares — used by the Produktband AND the ct15 person step.
        CwCasePersonPremiumSharesComponent,
        // The shared product overview (TARIFF_OVERVIEW, SUMMARY, OFFER).
        CwCaseProductOverviewComponent,
        // [CW-STEP-HEADER] The ONE step header bar, mounted by the step templates themselves.
        CwCaseObjectStepHeaderComponent,
        // CONSULTANT_DOCUMENTATION: one step composing the four Beratungs-sections.
        CwCaseObjectStepConsultantDocumentationComponent,
        // [CW-CONSULTATION-DOC-STEP] CONSULTATION_DOC: the option select that PROVIDES the
        // Beratungsdokumentation — it stands in front of the step above, it does not replace it.
        CwCaseObjectStepConsultationDocComponent,
        CwCaseObjectStepDocumentsComponent,
        CwCaseObjectStepQuestionsComponent,
        CwCaseObjectStepProductDataComponent,
        CwCaseObjectStepProductObjectAssignmentComponent,
        CwCaseObjectStepGenericFieldsComponent,
        CwCaseObjectStepCoveragesComponent,
        // [CW-VP-DIM] PERSON_COVERAGES + the shared building blocks its Bausteine and its
        // proposal bar are made of (the COVERAGES step mounts the card list too, but NOT the bar —
        // the bar is PERSON_COVERAGES-only).
        //
        // [CW-TABLE·E-5] The TABLE rendering that stood beside the card list is GONE — deleted with
        // the tile swap, on the user's decision, after it had lost its last mounting point. Both
        // steps render CwCoverageCardListComponent now. It needs no extra PrimeNG import: p-checkbox,
        // p-select and p-inputNumber all arrive via CoreModule → SharedModule.
        CwCaseObjectStepPersonCoveragesComponent,
        CwCoverageCardListComponent,
        CwDefaultProposalBarComponent,
        CwCaseObjectStepOfferComponent,
        CwCaseObjectStepTariffOverviewComponent,
        CwCaseObjectStepRequestApplicationComponent,
        CwCaseObjectStepOrderComponent,
        // [CW-TAA-V3] SUMMARY
        CwCaseObjectStepCaseSummaryComponent,
        CwCaseCreatePage,
        // [CW-QUICK-LAUNCH]
        CwCaseQuickLaunchPage,
        CwCasePhoneConsentComponent,
        CwCaseChannelTilesComponent,
        CwCaseCreateSelectionComponent,
        CwCaseCreateStepHeaderComponent,
        CwCaseQuickSelectComponent,
        CwCaseUniversalSelectComponent,
        // The shared selection ROW. Needs no additional module import: <mvs-icon> arrives through
        // CoreModule -> SharedModule, the same way cw-case-universal-select already reaches it.
        CwSelectRowComponent,
        CwCaseQuickQuotePanelComponent,
        CwCasePhaseListComponent,
        CwCaseQuickQuoteObjectComponent,
        CwCaseObjectSidebarComponent,
        CwCaseObjectHeaderComponent,
        CwCaseTicketCreateComponent,
        CwCaseObjectFooterComponent,
        CwCaseObjectSummaryComponent,
        CwCaseObjectPdfPanelComponent,
        // [CW-CASETYPE30 / Schnellerfassung] Exported like the rest of the cw inventory: a shell that
        // imports CwModule gets the whole area. The directive belongs here MANDATORILY — without it, a
        // foreign caller could still supply <ng-template mvsCwWorkPanelTab>, but would get an empty
        // panel without a single error (see reasoning in the declarations list).
        CwCaseWorkPanelComponent,
        CwWorkPanelTabDirective,
        CwCaseLocalDocumentsComponent,
        CwCaseTransportPanelComponent,
        CwCaseDocumentGenerateSectionComponent,
        CwCaseNotificationGenerateSectionComponent,
        CwCaseTicketListComponent,
        // [CW-CT30 POLICY-WAIT] The shared Rückfragen-Status switch — mounted by „Warte auf Police"
        // today, and the one place the four buttons and their clickability live.
        CwCaseInquiryStatusComponent,
        CwCaseHistorySectionComponent,
        CwCasePolicyCompletionSectionComponent,
        CwCaseCommunicationSectionComponent,
        // [CW-SCHEMA] Datenvorschau (Export-Modell + BODY-XML) am offenen Vorgang
        CwCaseExchangePreviewSectionComponent,
        CwCaseContextHeaderComponent,
        CwCaseCancelActionComponent,
        CwCaseFindingListComponent,
        CwCaseStepFindingPanelComponent,
        CwCaseFieldEventLineComponent,
        CwCasePremiumProvisionalHintComponent,
        CwCarrierScopeBadgeComponent,
        CwCaseInlineComponent,
        CwCaseFieldHintComponent,
        CwCaseStepOperationStatusComponent,
        CwCaseHelpBoxComponent,
        CwResolveSubmissionDialogComponent,
        CwCaseApprovalIndicatorComponent,
        CwExchangeConfigCheckPanelComponent,
        CwExchangeRenderPreviewPanelComponent,
        CwConsultationSectionRendererComponent,
        CwConsultationWorkbenchComponent,
        // [T2 · P3] Abschluss-/Wiederoeffnen-Aktionsleiste
        CwConsultationClosureActionsComponent,
        CwConsultationDocObjectComponent,
        CwConsultationDocObjectPage,
        // [Beratungsdok-Redesign]
        CwConsultationWorkbenchRedesignComponent,
        CwConsultationRedesignHeaderComponent,
        CwConsultationRedesignNavComponent,
        CwConsultationRedesignDocumentComponent,
        CwConsultationRedesignSectionComponent,
        CwConsultationDocRedesignComponent,
        CwConsultationDocRedesignPage,
    ],
    providers: [
        CW_ENTITY_PROVIDER,
        {provide: ConfirmationService, useClass: MvsConfirmationService},
        // TM-1000002000: the overlay of cw.CwCase is the full Vorgang in every shell unless the shell's
        // AppModule overrides this token (the consultant shell does, see CONSULTANT_PROVIDERS).
        {provide: CW_CASE_PAGE_COMPONENT, useValue: CwCaseObjectComponent},
        // [CW-CT30] A page-mounted Vorgang returns to the „Vorgänge" worklist after the closing LocalCase step
        // unless the shell's AppModule overrides this token (the consultant shell does, with null).
        {provide: CW_LOCAL_SUBMIT_RETURN_TARGET, useValue: CW_LOCAL_SUBMIT_RETURN_TO_CASE_WORKLIST},
        // [cw alternate display] „Zur Vorgangsübersicht" of a restricted step leads to the „Vorgänge" section of
        // the Qualitätscenter unless the shell's AppModule overrides this token (the consultant shell does,
        // with „Meine Anträge").
        {provide: CW_STEP_ALTERNATE_DASHBOARD_TARGET, useValue: CW_STEP_ALTERNATE_DASHBOARD_ALPHA},
    ]
})
export class CwModule implements DynamicModule {

    alias = 'cw';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return null;
    }

    getStatisticsComponent() {
        return null;
    }

}
